export const getEventsListing = '/api/v1/events';
export const isDownloadable = '/api/v1/events/summit/attendee/certificate/downloadable';
export const getMcdEvent = eventHashedId => `/api/v1/events/mcd/${eventHashedId}`;
export const mcdRegisterFree = eventId => `/api/v1/events/mcd/${eventId}/register/free`;
export const mcdRegisterNew = eventId => `/api/v1/events/mcd/${eventId}/register`;
export const mcdRegisterSingle = eventId => `/api/v1/events/mcd/${eventId}/register/single`;
export const mcdRegisterUpgrade = eventId => `/api/v1/events/mcd/${eventId}/register/upgrade`;
export const mcdRegisterRenewal = eventId => `/api/v1/events/mcd/${eventId}/register/renew`;
export const getEventSessions = eventId => `/api/v1/events/${eventId}/sessions`;
export const getEventSpeakers = eventId => `/api/v1/events/${eventId}/speakers`;
export const getEventFaqs = eventId => `/api/v1/events/${eventId}/faqs`;


